module.exports = __webpack_public_path__ + "img/firma.0554e0d1.svg";